import analytics from 'hb4e-ui-analytics'
import { selectors as authenticationSelectors } from 'hb4e-ui-authentication'
import { ProductService, PRODUCT_FORMAT_DISPLAY_VALUES, PRODUCT_LANGUAGE_DISPLAY_VALUES } from 'hb4e-ui-product'
import { List } from 'hb4e-ui-context'
import { CoreUtils } from 'hb4e-ui-core'

import { selectLists, selectActiveList } from './reducers'
import { listsPageType, listDetailPageType } from './constants'

const { selectUser } = authenticationSelectors
const { getProductPriceNew } = ProductService
const { customHistory } = CoreUtils

const formatListItem = (item, user) => {
  const {
    product = {},
    productCoreId = '',
    availabilityId = '',
    authors = '',
    publicationDate = '',
    marketingCategory = '',
  } = item
  const format = availabilityId.split('-')[1]
  const language = availabilityId.split('-')[2]
  const primaryAuthor = authors.split(', ')[0]
  const authorsFormatted = authors.split(', ').join('|')
  const displayPrice = getProductPriceNew(product, user).mainPrice
  const fullPrice = getProductPriceNew(product, user).secondaryPrice || displayPrice

  return {
    itemName: product.title,
    itemID: availabilityId,
    coreID: productCoreId,
    itemSKU: availabilityId,
    itemPrice: displayPrice,
    itemPrimaryAuthor: primaryAuthor,
    itemAuthors: authorsFormatted,
    itemType: marketingCategory,
    itemFormat: PRODUCT_FORMAT_DISPLAY_VALUES[format],
    itemLanguage: PRODUCT_LANGUAGE_DISPLAY_VALUES[language],
    itemPublicationDate: analytics.utils.formatDate(publicationDate),
    itemSize: `${product.lengthValue} ${product.lengthType}`,
    freeSample: false,
    itemDisplayPrice: displayPrice,
    itemFullPrice: fullPrice,
  }
}

analytics.onPageLoad(listsPageType, () => (dispatch, getState) => {
  const state = getState()
  const [searchParams] = customHistory.searchParams
  const term = searchParams.get('term')
  const lists = selectLists(state)

  if (term) {
    const resultsLength = lists.filter((list) => list.getName().toLowerCase().includes(term.toLowerCase())).length

    analytics
      .addPageInfo({
        onsiteSearchTerm: term,
        onsiteSearchResults: resultsLength,
        onsiteSearchType: resultsLength > 0 ? 'Keyword Searches - Success' : 'Keyword Searches - Failed',
        onsiteSearchSort: 'List Name',
      })
      .recordEvent('Search Interaction', 'Search Refined')
  }
})

analytics.onPageLoad(listDetailPageType, () => async (dispatch, getState) => {
  const state = getState()
  const activeList = await analytics.utils.waitFor(() => selectActiveList(state)?.list)

  const user = selectUser(state)

  analytics
    .addPageInfo({
      pageName: activeList.getName(),
    })
    .addTopLevelData('list', {
      listName: activeList.getName(),
      listID: activeList.getServerID(),
      listCreationDate: analytics.utils.formatDate(activeList.getCreatedDate()),
      listLastUpdatedDate: analytics.utils.formatDate(activeList.getUpdatedDate()),
      listStatus: 'Active',
      items: activeList.getItems().map((item) => formatListItem(item, user)),
    })
})

export const recordListUpdatedEvent = (list) => {
  // TODO: (KR: 09/28/22) - This will need to be removed when the list passed here will be an instance of a list
  const activeList = new List(list)

  analytics.recordEvent('List Interaction', 'List Update', {
    listID: activeList.getServerID(),
    listName: activeList.getName(),
    additionSource: 'List Page',
  })
}

export const recordListDeletedEvent = (list, options) => {
  analytics.recordEvent('List Interaction', 'List Deletion', {
    listID: list.getServerID(),
    listName: list.getName(),
    additionSource: options.additionSource,
    items: [],
  })
}

export const recordItemRemovedFromListEvent = (list, item, options) => (dispatch, getState) => {
  const user = selectUser(getState())

  analytics.recordEvent('Item Interaction', 'List Removal', {
    listID: list.getServerID(),
    listName: list.getName(),
    additionSource: options.additionSource,
    items: [formatListItem(item, user)],
  })
}

export const recordShareListEvent = () => async (dispatch, getState) => {
  const state = getState()
  const activeList = await analytics.utils.waitFor(() => selectActiveList(state)?.list)
  const user = selectUser(getState())

  analytics.recordEvent('List Interaction', 'List Share', {
    listID: activeList.getServerID(),
    listName: activeList.getName(),
    additionSource: 'List Page',
    items: activeList.getItems().map((item) => formatListItem(item, user)),
  })
}
